import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { Theme } from '@mui/material/styles';
import useDesignTokens from '../../../../themes/useDesignTokens';

export const useSetupSuccessStyles = () => {
  const { sizeGuide, typography } = useTheme();
  const tokens = useDesignTokens();
  const theme: Theme = useTheme();
  return useMemo(
    () => ({
      mainContainer: {
        display: 'flex',
        height: 'calc( 100vh - 80px )',
        alignItems: 'center',
        justifyContent: 'center',
        padding: `${sizeGuide['4xl']} ${sizeGuide['7xl']}`,
      },
      contentContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column' as const,
        gap: sizeGuide['4xl'],
        maxWidth: '512px',
        paddingBottom: sizeGuide['10xl'],
      },
      textContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column' as const,
        textAlign: 'center' as const,
        alignSelf: 'stretch',
        gap: sizeGuide.lg,
      },
      buttonContainer: {
        display: 'flex',
        flexDirection: 'column' as const,
        color: tokens.colors.text.secondary,
      },
      emphasisText: {
        color: tokens.colors.text.primary,
        fontWeight:
          typography?.body_14_medium?.fontWeight ?? typography.fontWeightMedium,
      },
      inlineLoader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        minWidth: sizeGuide['10xl'],
        height: sizeGuide['6xl'],
      },
      supportContainer: {
        alignItems: 'center',
        color: tokens.colors.text.secondary,
        display: 'flex',
        flexDirection: 'column' as const,
        gap: sizeGuide.xs,
      },
      supportInline: {
        alignItems: 'center',
        color: tokens.colors.text.secondary,
        display: 'flex',
        gap: sizeGuide.xs,
      },
      supportText: {
        color: tokens.colors.text.secondary,
        textAlign: 'center' as const,
      },
      supportLink: {
        minWidth: 'auto',
        padding: 0,
        display: 'inline-flex',
      },
      assetronButton: {
        padding: `${sizeGuide.md} ${sizeGuide.xl}`,
      },
      logoContainer: {
        height: '80px',
      },
      headerContainer: {
        display: 'flex',
        flexDirection: 'row',
        padding: `${theme.sizeGuide['2xl']} ${theme.sizeGuide['8xl']}`,
        justifyContent: 'space-between',
      },
    }),
    [sizeGuide, tokens, typography, theme],
  );
};
